import clsx from 'clsx';
import { bool, node, string } from 'prop-types';

const Card = ({ children, cta = null, title = null, onMobile = true, onTablet = true, className = '' }) => {
  return (
    <div
      className={clsx('card', className, {
        'rounded-xl shadow-card p-8 bg-white': onMobile,
        'md:rounded-xl md:shadow-card md:p-8 md:bg-white': !onMobile && onTablet,
        'lg:rounded-xl lg:shadow-card lg:p-8 lg:bg-white': !onMobile && !onTablet
      })}
    >
      {(title || cta) && (
        <div className={clsx('card-header flex items-center', { 'mb-7': title })}>
          {title && title}
          {cta && <div className="ml-auto">{cta}</div>}
        </div>
      )}

      <div className="card-content">{children}</div>
    </div>
  );
};

Card.propTypes = {
  children: node.isRequired,
  cta: node,
  title: node,
  onMobile: bool,
  onTablet: bool,
  className: string
};

export default Card;
